import React from 'react';

import { useEventPageContext } from 'app/fan/context/EventPage';
import { ExpressCheckoutContextProvider } from 'app/fan/context/ExpressCheckout';
import { StripeElementsProvider } from 'app/fan/context/StripeElementsProvider';

import { BuyFlowPrePurchaseContainer } from './BuyFlowPrePurchaseContainer';

export * from './BuyFlowPrePurchaseContainer';

export const BuyFlowPrePurchaseEventPage = () => {
  const { event, eventAttendee } = useEventPageContext();

  // We will never run into this scenario, but include this code so that
  // Typescript knows to expect this to be present
  if (!event) {
    return null;
  }

  return (
    <StripeElementsProvider eventId={event.id}>
      <ExpressCheckoutContextProvider
        event={event}
        eventAttendee={eventAttendee}
      >
        <BuyFlowPrePurchaseContainer />
      </ExpressCheckoutContextProvider>
    </StripeElementsProvider>
  );
};
